"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";

const ContactForm = dynamic(() => import("../layout/ContactForm"), {
  ssr: false,
  loading: () => (
    <div
      className="min-h-[240px] rounded-[10px] bg-[#f5f5f5]"
      aria-hidden="true"
    />
  ),
});

export default function LazyContactForm() {
  const [shouldLoad, setShouldLoad] = useState(false);
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = formRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "500px",
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={formRef}>
      {shouldLoad ? (
        <ContactForm />
      ) : (
        <div
          className="min-h-[240px] rounded-[10px] bg-[#f5f5f5]"
          aria-hidden="true"
        />
      )}
    </div>
  );
}